/* ePixel 07.10.2026 - id-uri unice pentru carusele.
   Tema randeaza acelasi id (ex. x-collection-t1) pentru fiecare sectiune de tip
   colectie cu tab-uri, iar Splide porneste cu new Splide("#" + id), deci prinde mereu
   primul element din pagina. Rezultat: doar primul carusel se initializa, restul ramaneau
   blocate (continut taiat, fara swipe). Aici facem id-urile unice inainte sa porneasca Splide. */
(function () {
  if (window.__pbSliderIds) return;
  window.__pbSliderIds = true;

  function dedupe() {
    var seen = {};
    document.querySelectorAll('.splide[id]').forEach(function (el) {
      var id = el.id;
      if (!id) return;
      if (el.classList.contains('is-initialized')) { seen[id] = true; return; }
      if (!seen[id] && document.querySelectorAll('[id="' + id.replace(/"/g, '\\"') + '"]').length === 1) {
        seen[id] = true;
        return;
      }
      if (!seen[id]) { seen[id] = true; return; }
      var n = 2, nou;
      do { nou = id + '-pbx' + n; n++; } while (document.getElementById(nou));
      el.id = nou;
    });
  }

  function start() {
    dedupe();
    var t = null;
    new MutationObserver(function () {
      clearTimeout(t);
      t = setTimeout(dedupe, 150);
    }).observe(document.documentElement, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
